import { deviceType, getUA, mobileModel, osName } from "react-device-detect";
import { camelize, capitalize } from "../../../../tracking/utils/string";

const WEB_THEME: { [index: string]: string } = {
  mobile: "Phone",
  tablet: "Tablet",
  desktop: "Desktop",
};

export function getProductName(brandName?: string) {
  return brandName ? "" : "AirHelpStandard";
}

export function getFunnelTrack({
  isOta = false,
  isBarcodeScanner = false,
  isBrazilEligible = false,
}: {
  isOta?: boolean;
  isBarcodeScanner?: boolean;
  isBrazilEligible?: boolean;
} = {}) {
  if (isOta) {
    return "Claim - OTA";
  }
  if (isBarcodeScanner) {
    return "Claim - Scanner";
  }
  if (isBrazilEligible) {
    return "Claim - Brazil";
  }
  return "Claim - Track";
}

export function detectActionByEnquiryStatus({ isEligible }: { isEligible?: boolean }) {
  if (typeof isEligible === "undefined") {
    return "EnquiryStepComplete";
  }

  if (isEligible) {
    return "ValidEnquiry";
  } else {
    return "InvalidEnquiry";
  }
}

export function getDisruptionTypeDetails({
  delay,
  claimType,
  airlineReason,
  informedBeforehand,
  voluntarilySurrendered,
}: {
  delay?: string;
  claimType?: string;
  airlineReason?: string;
  informedBeforehand?: string;
  voluntarilySurrendered?: boolean;
} = {}) {
  if (claimType === "delayed") {
    return {
      delayed_flight: {
        total_delay: capitalize(delay),
        disruption_reason: capitalize(airlineReason),
      },
    };
  }
  if (claimType === "cancelled") {
    return {
      cancelled_flight: {
        total_delay: capitalize(delay),
        disruption_reason: capitalize(airlineReason),
        disruption_notification: informedBeforehand ? "Y" : "N",
      },
    };
  }
  if (claimType === "overbooked") {
    return {
      denied_boarding: {
        total_delay: capitalize(delay),
        reservation_surrendered: voluntarilySurrendered ? "Y" : "N",
      },
    };
  }

  return {};
}
const pathsBeforeUuid: string[] = ["fellow", "claim_enquiries"];

function removeUuidFromPath(splitPath: string[]) {
  pathsBeforeUuid.forEach((pathBeforeUuid) => {
    const pathBeforeUuidIndex = splitPath.findIndex((path) => path === pathBeforeUuid);
    if (pathBeforeUuidIndex !== -1) splitPath.splice(pathBeforeUuidIndex + 1, 1);
  });
}

function createPageType() {
  const pathname = window.location.pathname;
  const splitPathname = pathname.split("/");

  removeUuidFromPath(splitPathname);
  return splitPathname.map((s) => camelize(s, true)).join("");
}

export function getPageInfo(previousPageUrl?: string) {
  return {
    page_url: window.location.href,
    page_path: window.location.pathname,
    page_type: createPageType(),
    page_title: document.title,
    page_referrer: previousPageUrl || document.referrer,
  };
}

export function getDeviceInfo() {
  return {
    user_agent: getUA,
    device_type: capitalize(deviceType),
    device_model: mobileModel || osName,
    web_theme: WEB_THEME[deviceType],
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
  };
}
